import {
  QBox,
  QFormControl,
  QSelect,
  QSelectPlaceholder,
  QText,
} from '@qualio/ui-components';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUsers } from '../../../hooks/useUsers';

type OwnerFilterFieldProps = {
  name: string;
  dataCy: string;
};

export const OwnerFilterField = ({ name, dataCy }: OwnerFilterFieldProps) => {
  const { t } = useTranslation();
  const { data: users = [], isLoading } = useUsers();

  const ownerOptions = useMemo(
    () =>
      [...users]
        .sort((a, b) => a.full_name.localeCompare(b.full_name))
        .map((user) => ({
          value: String(user.id),
          label: user.full_name,
        })),
    [users],
  );

  return (
    <QFormControl label={t('labels.owner')}>
      <Controller
        name={name}
        render={({ field: { onChange, value, ...field } }) => (
          <QBox data-cy={dataCy}>
            <QSelect
              {...field}
              options={ownerOptions}
              value={value ?? null}
              onChange={(item) => onChange(item?.value ?? null)}
              isClearable={true}
              clearInputOnSelect={value == null}
              isLoading={isLoading}
            >
              <QSelectPlaceholder>
                <QText>{t('forms.filterByOwner')}</QText>
              </QSelectPlaceholder>
            </QSelect>
          </QBox>
        )}
      />
    </QFormControl>
  );
};
